import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getFirebaseToken } from "../utils/getFirebaseToken";
import { fetchLowStockItems } from "../services/erpInventory";


export default function ERPDashboardPage() {
  const [lowStockRows, setLowStockRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

const params = new URLSearchParams(location.search);
const resourceItemId = params.get("resource_item_id");

  const loadLowStock = async () => {
    setLoading(true);
    try {
      const token = await getFirebaseToken();
      const res = await fetchLowStockItems(token);
      setLowStockRows(res.rows || []);
    } catch (err) {
      console.error("Failed to load low stock items:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLowStock();
  }, []);

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="mb-2">
        <h1 className="text-2xl font-bold">ERP Dashboard</h1>
        <p className="text-slate-600">
          Central place for ERP resource documents and inventory overview.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Link to="/erp/documents" className="bg-white border rounded-xl p-5 shadow-sm">
          <div className="text-lg font-semibold mb-2">Documents</div>
          <div className="text-slate-600">
            Create, edit, approve and post ERP documents.
          </div>
        </Link>

        <Link to="/erp/documents/new" className="bg-white border rounded-xl p-5 shadow-sm">
          <div className="text-lg font-semibold mb-2">New Document</div>
          <div className="text-slate-600">
            Start a new goods receipt, issue or transfer.
          </div>
        </Link>

        <Link to="/erp/inventory" className="bg-white border rounded-xl p-5 shadow-sm">
          <div className="text-lg font-semibold mb-2">Inventory</div>
          <div className="text-slate-600">
            See current stock balances by warehouse and location.
          </div>
        </Link>

        <Link to="/erp/resource-items" className="bg-white border rounded-xl p-5 shadow-sm">
          <div className="text-lg font-semibold mb-2">Resource Items</div>
          <div className="text-slate-600">
            Manage materials, tools, equipment and stock parameters.
          </div>
        </Link>

        <Link to="/erp/purchase-orders" className="bg-white border rounded-xl p-5 shadow-sm">
  <div className="text-lg font-semibold mb-2">Purchase Orders</div>
  <div className="text-slate-600">
    Create and manage procurement orders by supplier.
  </div>
</Link>

        <Link to="/erp/supplier-items" className="bg-white border rounded-xl p-5 shadow-sm">
  <div className="text-lg font-semibold mb-2">Supplier Mapping</div>
  <div className="text-slate-600">
    Map internal items to supplier SKUs and maintain sourcing prices.
  </div>
</Link>
      </div>

      <div className="bg-white border rounded-xl p-5 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold">Low Stock Alerts</h2>
            <p className="text-slate-600 text-sm">
              Items at or below minimum stock quantity.
            </p>
          </div>

          <div className="text-right">
            <div className="text-sm text-slate-500">Alert Count</div>
            <div className="text-2xl font-bold text-red-600">
              {lowStockRows.length}
            </div>
          </div>
        </div>

        {loading ? (
          <div className="text-slate-500">Loading alerts...</div>
        ) : lowStockRows.length === 0 ? (
          <div className="text-slate-500">No low stock alerts.</div>
        ) : (
          <div className="space-y-2">
            {lowStockRows.slice(0, 5).map((row) => (
              <Link
  key={row.id}
  to={`/erp/inventory?resource_item_id=${row.resource_item_id}`}
  className="flex items-center justify-between border rounded-lg px-4 py-3 bg-red-50 hover:bg-red-100"
>
  <div>
    <div className="font-medium">
      {row.resource_code ? `${row.resource_code} - ` : ""}
      {row.resource_name || row.resource_item_id}
    </div>
    <div className="text-sm text-slate-600">
      {row.warehouse_name || row.warehouse_id} /{" "}
      {row.location_name || row.location_id}
    </div>
  </div>

  <div className="text-right text-sm">
    <div>
      On hand:{" "}
      <span className="font-semibold">
        {Number(row.qty_on_hand || 0).toFixed(4)}
      </span>
    </div>
    <div>
      Min:{" "}
      <span className="font-semibold">
        {Number(row.min_stock_qty || 0).toFixed(4)}
      </span>
    </div>
    <div>
      Reorder:{" "}
      <span className="font-semibold">
        {Number(row.reorder_qty || 0).toFixed(4)}
      </span>
    </div>
  </div>
</Link>
            ))}

            <div className="pt-2">
              <Link
                to="/erp/inventory"
                className="inline-flex px-4 py-2 rounded-lg border"
              >
                Open Inventory
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}